const styles = (theme) => ({
  pricingInfoContainer: {
    margin: theme.spacing(3.75, 2.5, 2),
    padding: 0,
    width: 'auto',
  },
  returnOrderPricing: {
    marginTop: theme.spacing(10),
    padding: theme.spacing(3.75, 3, 2.5),
    backgroundColor: theme.color.grey_f6,
    width: 'auto',
  },
  card: {
    marginRight: theme.spacing(1.25),
    width: 'auto',
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  title: {
    opacity: 1,
  },
  multiplePayments: {
    gap: 10,
  },
});

export default styles;
